export const _getOptions = (list, valueKey, label = "Name") => {
  try {
    return list.map((item) => {
      return {
        value: item[valueKey],
        label: item[label],
      };
    });
  } catch (error) {
    return [];
  }
};
